export * from './assets';

class WebpackBackend {
    constructor() {
        this.type = 'backend';
    }
    init(_services, _backendOptions, _i18nextOptions) { }
    read(language, namespace, callback) {
        this.import(language, namespace)
            .then((result) => {
            callback(null, result);
        })
            .catch((err) => {
            callback(err, null);
        });
    }
    create(_languages, _namespace, _key, _fallbackValue) { }
}
class DesignWebpackBackend extends WebpackBackend {
    import(language, bundleName) {
        if (language !== 'en') {
            return Promise.reject('Only en is supported by DesignWebpackBackend');
        }
        if (!/^SASDesign-[\w]+-gui-icu$/.test(bundleName)) {
            return Promise.reject(`Bundle named ${bundleName} is not supported by DesignWebpackBackend`);
        }
        // @ts-ignore
        return import('./SASDesign-Icon-gui-icu.properties').then((m) => m.default);
    }
}

export { DesignWebpackBackend };
